<template>
    <div class="id">
        <h3 style="padding-top: 60px;"><span>GTP</span>{{ $t('登陆') }}</h3>
        <h5 style="color: #7e7e7e;padding-top: 6px;">
            <!-- {{ $t('欢迎回来！使用您的电子邮件、电话号码登录') }} -->
            {{ $t('欢迎回来！使用您的电子邮件登录') }}
        </h5>
        <!-- <div class="title"> {{ $t('邮箱') }}</div> -->
        <div class="account">{{ $t('邮箱') }}</div>
        <van-field v-model="account" :placeholder="$t('请输入账号')" />
        <div class="account">{{ $t('密码') }}</div>
        <van-field v-model="password" type="password" :placeholder="$t('请输入密码')" />
        <div style="display: flex;align-items: center;">
            <van-checkbox v-model="checked" shape="square" class="van-checkbox" icon-size="14">
            </van-checkbox>
            <div style="padding-left: 10px;font-size: 14px;color: #999;">{{ $t('记住密码') }}</div>
        </div>
        <div class="btn" @click="login">{{ $t('登陆') }}</div>
        <div class="register" @click="$router.push('/mobile/register')">{{ $t('注册') }}</div>
        <!-- <div class="forget" @click="$router.push('/mobile/forget')">忘记密码</div> -->
        <div class="forget" @click="kefuCk">{{ $t('忘记密码') }}</div>
    </div>
</template>
<script>
import { post } from '@/http/request'
import { openKefu } from '@/common/public.js'

export default {
    components: {
    },
    data() {
        return {
            account: localStorage.getItem('account') || '',
            password: localStorage.getItem('password') || '',
            checked: !!localStorage.getItem('password'),
            kefu: localStorage.getItem('kefuW'),
        };
    },
    mounted() {
        if (localStorage.getItem('token')) {
            this.$nav.go('/mobile/home')
            return
        }
    },
    beforeUnmount() { },
    methods: {
        login() {
            post(this.$apis.login, { account: this.account, password: this.password }).then(res => {
                if (res.code == 1) {
                    if (this.checked == true) {
                        localStorage.setItem('account', this.account)
                        localStorage.setItem('password', this.password)
                    } else {
                        localStorage.setItem('account', '')
                        localStorage.setItem('password', '')
                    }
                    this.$store.commit('setUserInfo', res.data.userinfo)
                    this.$store.commit('setToken', res.data.userinfo.token)
                    this.$notify.success(res.msg)
                    // 延时跳转，让用户看到提示
                    setTimeout(() => {
                        this.$nav.go('/mobile/home')
                    }, 800)
                }
            })
        },
        kefuCk() {
            // window.open(this.kefu, '_blank')
            openKefu()
        },
    },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding: 20px;

    .van-cell {
        background-color: #000 !important;
        border: 1px solid #3e444c;
        color: #3e444c !important;
    }

    .van-cell::after {
        border-bottom: 0px solid #000;
    }

    ::v-deep .van-field__control {
        color: #fff !important;
    }

    .title {
        display: inline-block;
        background-color: #00f0ff;
        padding: 10px 20px;
        border-radius: 10px;
        font-size: 16px;
        margin-top: 20px;
        color: #000;
    }

    .account {
        padding-top: 20px;
        padding-bottom: 10px;
    }

    .van-checkbox {
        padding: 20px 0;
    }

    ::v-deep .van-checkbox__label {
        margin-left: 26px !important;
        font-size: 26px;
    }

    .btn {
        cursor: pointer;
        color: #000;
        background-color: #00f0ff;
        text-align: center;
        padding: 10px 0;
        border-radius: 4px;
        margin-bottom: 20px;
    }

    .register {
        color: #00f0ff;
    }

    .forget {
        color: #00f0ff;
        padding-top: 20px;
    }

}
</style>
